import React from 'react'
import { useTranslation } from 'react-i18next'

export interface CommonWebsiteLayoutBodyProps {
  header: React.ReactNode
  content?: React.ReactNode
  footer: React.ReactNode
}

export const CommonWebsiteLayoutBody = ({
  header,
  content,
  footer,
}: CommonWebsiteLayoutBodyProps) => {
  const { t } = useTranslation()

  return (
    <div className="relative w-full">
      {header}
      <main>
        {content ?? (
          <div className="min-h-[640px] w-full bg-bgPrimaryBase">
            {t('components.website_layout_body.content_placeholder')}
          </div>
        )}
      </main>
      {footer}
    </div>
  )
}
